import React, { useEffect, useState } from 'react';
import { AddCircleOutline, ArrowBackIos } from '@mui/icons-material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { useResaveScenesMutation } from '../../../services/scenes/sceneService';
import { ScenesListLightShowsTemplate } from '../../../templates/applications/lightShows/scenesLightShowsListTemplate';
import { ReOpenSideBarIcon } from '../../../components/commons/reOpenSideBarIcon/reOpenSideBarIcon';
import { Header } from '../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import Strings from '../../../i18n';
import { ButtonIconStyled } from '../../devices/devicesStyles';
import { ISceneLightShow } from '../../../types/Scenes/scenesTypes';
import { useGetSceneLightShowListByLocationMutation } from '../../../services/sequences/sequencesService';
import { SceneType } from '../../../types/sceneType';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { SceneLightShowDetails } from '../../../templates/applications/lightShows/sceneLightShowDetails/sceneLightShowDetails';

export const ScenesViewLightShow = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [getScenesByLocId, { isSuccess, data, isLoading }] =
    useGetSceneLightShowListByLocationMutation();
  const [resaveScenes] = useResaveScenesMutation();
  const [openSideBar, setOpenSideBar] = useState(false);
  const [showSelectTypeAddScene, setShowSelectTypeAddScene] = useState(false);
  const [selectedScenes, setSelectedScenes] = useState<ISceneLightShow[]>([]);
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.addScene
  );
  const [editingSceneId, setEditingSceneId] = useState<number | null>(null);

  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  const reloadTable = () => {
    if (locationId) {
      getScenesByLocId({
        locationId: parseInt(locationId, 10),
        sceneType: SceneType.Playground
      });
    }
  };

  useEffect(() => {
    if (selectedScenes.length === 1) {
      openRightSideBarForMethod(viewRightSideBarEnum.sceneDetails);
    } else if (selectedScenes.length > 1) {
      openRightSideBarForMethod(
        viewRightSideBarEnum.multipleOrganizationsDetails
      );
    } else {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    }
  }, [selectedScenes]);

  useEffect(() => {
    if (locationId) {
      reloadTable();
    }
  }, []);

  const switchComponentToShowRightSideBar = () => {
    switch (sideBarOpenFor) {
      case viewRightSideBarEnum.sceneDetails:
        return (
          <SceneLightShowDetails
            scene={selectedScenes[0]}
            setOpenSideBar={setOpenSideBar}
            openSideBar={openSideBar}
            setSelectedScenes={setSelectedScenes}
            selectedScenes={selectedScenes}
            reloadTable={reloadTable}
          />
        );
      default:
        return <p />;
    }
  };
  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.ScenesViewLightShow.title}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              <Tooltip title={Strings.scenes.resave}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    resaveScenes(Number(locationId));
                  }}
                >
                  <SaveAltIcon />
                </ButtonIconStyled>
              </Tooltip>
              <Tooltip title={Strings.scenes.addSceneTitle}>
                <ButtonIconStyled
                  disabled
                  size="small"
                  onClick={() => {
                    setShowSelectTypeAddScene(true);
                  }}
                >
                  <AddCircleOutline />
                </ButtonIconStyled>
              </Tooltip>
              <ReOpenSideBarIcon
                isOpenRightSideBar={openSideBar}
                selectedItems={selectedScenes}
                singleItemMethod={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.organizationDetails
                  );
                }}
                multipleItemsMethod={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.multipleOrganizationsDetails
                  );
                }}
              />
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <ScenesListLightShowsTemplate
        selectedScenes={selectedScenes}
        setSelectedScenes={setSelectedScenes}
        scenes={data ?? []}
        isLoading={isLoading}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
